@for (trucksUsed of trucks?.trucks; track $index) {
    <div
        [class.red]="trucksUsed > todaysTruckCount"
        [class.print]="print"
        [class.darker]="todaysTruckCount / 2 > trucksUsed">
        {{ todaysTruckCount - trucksUsed }}
    </div>
}
